module.exports = __webpack_public_path__ + "static/media/gd_logo.45469c61.svg";